var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#564AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 29.929V33.0721C34.0002 33.2972 33.915 33.5139 33.7615 33.6785C33.6081 33.8431 33.3979 33.9435 33.1734 33.9592C32.7853 33.9865 32.4683 34.0001 32.2223 34.0001C24.3672 34.0001 18 27.633 18 19.7778C18 19.5325 18.0136 19.2154 18.0409 18.8267C18.0566 18.6022 18.157 18.392 18.3216 18.2386C18.4862 18.0852 18.703 17.9999 18.928 18H22.0711C22.1814 17.9999 22.2878 18.0408 22.3696 18.1147C22.4514 18.1886 22.5028 18.2903 22.5138 18.4C22.534 18.6039 22.5529 18.7674 22.5707 18.8907C22.7473 20.1235 23.1094 21.3225 23.6445 22.4471C23.7289 22.6249 23.6738 22.8374 23.5138 22.9511L21.5956 24.3218C22.7687 27.0545 24.9465 29.2323 27.6792 30.4054L29.0481 28.4907C29.1038 28.4122 29.1854 28.3559 29.2786 28.3317C29.3718 28.3075 29.4705 28.3169 29.5574 28.3583C30.6819 28.8924 31.8806 29.2535 33.113 29.4294C33.2363 29.4472 33.3992 29.4662 33.6019 29.4863C33.7114 29.4975 33.8129 29.549 33.8866 29.6308C33.9604 29.7126 34.0002 29.8189 34.0001 29.929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.22785d313a066d64891705c8ca851e88.svg";
export { ForwardRef as ReactComponent };